import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import
  {
    CompanyService,
    CustomerService,
    UtilityService,
  } from "src/app/services";

import
  {
    WebCompany,
    WebSwoDeliveryRequest,
    WebCustomer,
    CustomerClient,
    UtilityClient,
  } from "src/app/models";
import { Subscription } from "rxjs";
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { filter } from "rxjs/operators";
@Component({
  selector: "app-auto-pay-request-dialog",
  templateUrl: "./auto-pay-request-dialog.component.html",
  styleUrls: ["./auto-pay-request-dialog.component.scss"],
})
export class AutoPayRequestDialogComponent implements OnInit
{
  emailForm: FormGroup;
  public showCustHeader: boolean = true;
  public isSubmitted: boolean = false;

  companySubscription: Subscription;
  company: WebCompany;

  customerSubscription: Subscription;
  customer: WebCustomer;

  customerClient: CustomerClient;
  utilityClient: UtilityClient;
  emailRequest: WebSwoDeliveryRequest = {};
  requestData: WebSwoDeliveryRequest = { ...this.emailRequest };

  constructor(
    // private spinnerService: SpinnerService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AutoPayRequestDialogComponent>,
    private companyService: CompanyService,
    private customerService: CustomerService,
    private utilityService: UtilityService
  ) { }
  ngOnInit(): void
  {
    this.emailForm = this.fb.group({
      Email: ["", [Validators.required, Validators.email]],
    });
    this.companySubscription = this.companyService.company.subscribe((company) => 
    {
      this.company = company;
    });
    this.customerSubscription = this.customerService.customer.subscribe(customer =>
    {
      this.customer = customer;
    });
  }

  handleSubmit(): void
  {

    this.isSubmitted = true;
    this.requestData.ContactEmail = this.email;
    this.requestData.CustId = this.customer.CustId;
    this.requestData.Contact = this.customer.Name;
    this.requestData.Company = this.company;
    this.requestData.Customer = this.customer;
    this.utilityService.sendAutopayEmails(this.requestData).subscribe(r =>
    {
      if (r)
      {
        this.dialog.open(AlertDialogComponent, {
          id: "autopay-request-alert",
          panelClass: "form-field-less-than-180",
          width: "500px",
          height: "200px",
          data: {
            title: "Autopay request sent",
            message: "Your request has been sent to: " + this.company.Name + ".\n The company will review your account. ", buttonText: "Close"
          }
        });
      }
    }, (error) => { this.errorDialog(error); })
    this.dialogRef.close();
  }

  public ngOnDestroy(): void
  {
    this.companySubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
  }
  get email(): string
  {
    return this.emailForm.get("Email").value;
  }


  errorDialog(error): void
  {
    const errorMessage: string = "There was an error sending the email."; // error message to display in error dialog

    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      minWidth: "360px",
      data: errorMessage,
    });
    dialogRef.afterClosed().subscribe((_) =>
    {
      this.isSubmitted = false; // show form again
    });
  }
}
